export enum ParseValidType {
  Valid = 0,
  Duplicate = 1,
  Invalid = 2,
}

/**
 * 格式化时间（纳秒 → 毫秒字符串）
 * 保留两位小数，向上取整，最小为0.01ms
 */
export function formatTime(ns: number): string {
  const ms = ns / 1000000;
  return (Math.ceil(ms * 100) / 100).toFixed(2) + "ms";
}

/**
 * 格式化内存（字节 → 带单位字符串）
 * < 1KB 显示 B，< 1MB 显示 KB，其余显示 MB，保留两位小数
 */
export function formatMemory(bytes: number): string {
  const mb = bytes / 1024 / 1024;
  const kb = bytes / 1024;
  if (mb >= 1) {
    return mb.toFixed(2) + "MB";
  } else if (kb >= 1) {
    return kb.toFixed(2) + "KB";
  } else {
    return bytes.toFixed(2) + "B";
  }
}
